import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client, { ProfileData } from 'api/client'
import { useQuery, UseQueryOptions } from 'react-query'

export const useUserCard = (userId?: number, options: UseQueryOptions<any> = {}) => {
  return useQuery<ProfileData | undefined>(
    ['user-card', userId],
    async () => {
      if (!userId) {
        return
      }
      const res = await client.getUserCard(userId)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      ...options,
      enabled: !!userId,
      refetchOnWindowFocus: false,
    },
  )
}
